import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  APP_LANGUAGE_LABEL_KEYS,
  APP_LANGUAGE_ORDER,
  type AppLanguage,
} from '../../../shared/config';
import { BaseButton, SelectionCheckBadge } from '../../../shared/ui';

const Screen = styled.section.attrs({
  'data-ui': 'my-page-settings-language-screen',
})`
  padding-top: ${({ theme }) => theme.scale.px(6)};
`;

const Card = styled.div`
  border-radius: ${({ theme }) => theme.scale.px(10)};
  background: ${({ theme }) => theme.colors.surface.subtle};
  overflow: hidden;
`;

const RowDivider = styled.div`
  height: ${({ theme }) => theme.scale.px(1)};
  background: ${({ theme }) => theme.colors.border.divider};
`;

const RowButton = styled(BaseButton)`
  width: 100%;
  box-sizing: border-box;
  height: ${({ theme }) => theme.scale.px(48)};
  padding: 0 ${({ theme }) => theme.scale.px(22)};
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  column-gap: ${({ theme }) => theme.scale.px(12)};
  text-align: left;
`;

const Label = styled.span`
  font-size: ${({ theme }) => theme.scale.px(15)};
  line-height: ${({ theme }) => theme.scale.px(18)};
`;

const SelectionSlot = styled.span`
  width: ${({ theme }) => theme.scale.px(27)};
  height: ${({ theme }) => theme.scale.px(27)};
  display: grid;
  place-items: center;
  flex: 0 0 auto;
`;

type MyPageSettingsLanguageScreenProps = {
  currentLanguage: AppLanguage;
  onSelectLanguage: (language: AppLanguage) => void;
};

export function MyPageSettingsLanguageScreen({
  currentLanguage,
  onSelectLanguage,
}: MyPageSettingsLanguageScreenProps) {
  const { t } = useTranslation();

  return (
    <Screen>
      <Card>
        {APP_LANGUAGE_ORDER.map((language, index) => {
          const isSelected = language === currentLanguage;

          return (
            <div key={language}>
              <RowButton
                type="button"
                aria-current={isSelected ? 'true' : undefined}
                onClick={() => {
                  onSelectLanguage(language);
                }}
              >
                <Label>{t(APP_LANGUAGE_LABEL_KEYS[language])}</Label>
                <SelectionSlot aria-hidden>
                  {isSelected ? <SelectionCheckBadge /> : null}
                </SelectionSlot>
              </RowButton>
              {index < APP_LANGUAGE_ORDER.length - 1 ? <RowDivider /> : null}
            </div>
          );
        })}
      </Card>
    </Screen>
  );
}
